// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js","824":"component---src-templates-doc-js"}[chunkId] || chunkId) + "-" + {"125":"cd3aabb95318d3c048a1","293":"7b53859851ebe6144c4b","454":"136033e39508279441c1","824":"71e5a299c7cbdadd4b92"}[chunkId] + ".js";
};